/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_End_TcInputs */

const en_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert End TC On Insert`)
};

const fr_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer le TC de fin à l'insertion`)
};

const de_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC-Einsatz am Ende einfügen`)
};

const it_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci fine TC su Inserisci`)
};

const ru_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить конец TC при вставке`)
};

const es_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar extremo TC en inserto`)
};

const zh_cn2_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入结束 TC 插入`)
};

const ja_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入終了 TC 挿入時`)
};

const hi_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंसर्ट एंड टीसी ऑन इंसर्ट`)
};

const pt_pt2_options_editor_insert_end_tc = /** @type {(inputs: Options_Editor_Insert_End_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir Fim TC em Inserir`)
};

/**
* | output |
* | --- |
* | "Insert End TC On Insert" |
*
* @param {Options_Editor_Insert_End_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_end_tc = /** @type {((inputs?: Options_Editor_Insert_End_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_End_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_insert_end_tc(inputs)
	if (locale === "de") return de_options_editor_insert_end_tc(inputs)
	if (locale === "it") return it_options_editor_insert_end_tc(inputs)
	if (locale === "ru") return ru_options_editor_insert_end_tc(inputs)
	if (locale === "es") return es_options_editor_insert_end_tc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_insert_end_tc(inputs)
	if (locale === "ja") return ja_options_editor_insert_end_tc(inputs)
	if (locale === "hi") return hi_options_editor_insert_end_tc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_insert_end_tc(inputs)
	return en_options_editor_insert_end_tc(inputs)
});